// External dependencies
import classnames from 'classnames';
import React from 'react';

export default function AdminSidebar() {
  const currentPath =
    window.location.pathname.replace('/admin/', '') || 'dashboard';

  // Sidebar menu items - only up to audit log
  const sidebarItems = [
    {
      path: '',
      label: 'Dashboard',
      icon: '📊',
    },
    {
      path: 'user',
      label: 'Member report card',
      icon: '👤',
    },
    {
      path: 'search-users',
      label: 'Search members',
      icon: '🔍',
    },
    {
      path: 'messages',
      label: 'Messages',
      icon: '💬',
    },
    {
      path: 'threads',
      label: 'Threads',
      icon: '🧵',
    },
    {
      path: 'reference-threads',
      label: 'Reference threads',
      icon: '💭',
    },
    {
      path: 'acquisition-stories',
      label: 'Acquisition stories',
      icon: '📖',
    },
    {
      path: 'newsletter',
      label: 'Newsletter',
      icon: '📧',
    },
    {
      // Sub-sections (Pages, Trash, Announcements, Menus, Settings) are
      // reached from `CmsAdminNav` once inside.
      path: 'cms',
      label: 'CMS',
      icon: '📄',
    },
    {
      path: 'payments',
      label: 'Payment Settings',
      icon: '💳',
    },
    {
      path: 'audit-log',
      label: 'Audit log',
      icon: '📋',
    },
    {
      path: 'translate',
      label: 'Translation',
      icon: '🌐',
    },
  ];

  const renderMenuItem = ({ path, label, icon }) => {
    const isActive =
      currentPath === path ||
      (path === '' && currentPath === '') ||
      (path !== '' && currentPath.startsWith(`${path}/`));

    return (
      <li
        key={path || 'dashboard'}
        className={classnames('admin-sidebar__item', {
          'admin-sidebar__item--active': isActive,
        })}
      >
        <a href={`/admin/${path || ''}`} className="admin-sidebar__link">
          {icon && <span className="admin-sidebar__icon">{icon}</span>}
          <span className="admin-sidebar__label">{label}</span>
        </a>
      </li>
    );
  };

  return (
    <aside className="admin-sidebar">
      <div className="admin-sidebar__header">
        <a href="/admin" className="admin-sidebar__brand">
          <span className="admin-sidebar__brand-text">Admin Panel</span>
        </a>
      </div>
      <nav className="admin-sidebar__nav">
        <ul className="admin-sidebar__list">
          {sidebarItems.map(item => renderMenuItem(item))}
        </ul>
      </nav>
      <div className="admin-sidebar__footer">
        <button
          className="admin-sidebar__back-to-top"
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        >
          ⬆️ Back to Top
        </button>
      </div>
    </aside>
  );
}

AdminSidebar.propTypes = {};
